import { Modal } from 'antd';

import { rem } from 'polished';
import styled from 'styled-components';

import { BODY_2_REG_2, BUTTON_2_2 } from 'src/client/constants/text';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-content {
    border-radius: 8px;
  }

  width: 90vw !important;

  @media ${(props) => props.theme.screen.sm} {
    width: inherit !important;
    max-width: 500px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 24px 24px 0;
`;

export const ImageCover = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const FooterContainer = styled.div`
  padding: 24px 24px 32px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  & .ant-checkbox-wrapper > span:last-child {
    ${BODY_2_REG_2}
    color: ${(props) => props.theme.colors.darkEmphasis2};

    font-size: ${rem('12px')};
    line-height: ${rem('16px')};

    @media ${(props) => props.theme.screen.sm} {
      font-size: inherit;
      line-height: inherit;
    }
  }

  & .ant-btn span {
    font-size: ${rem('12px')};
    line-height: ${rem('16px')};

    @media ${(props) => props.theme.screen.sm} {
      ${BUTTON_2_2}
    }
  }
`;

export const ItalicText = styled.span`
  font-family: inherit;
  font-style: italic;
`;
